module.exports = __webpack_public_path__ + "static/media/austin-prep.6c7e7417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/austin-prep.png
// module id = 612
// module chunks = 0